// initial state
const state = () => ({
    tickets: [],
})

// getters
const getters = {
}

// actions
const actions = {
    getTickets: async ({ commit }) => {
        return await axios.get('support-ticket').then(({ data }) => {
            commit('setTickets', data);
            return data;
        }).catch((error) => {
            throw error.response?.data;
        });
    },

    storeTicket: async ({ state, commit }, inputData) => {
        console.log('storeTicket', inputData);
        return await axios.post('support-ticket', inputData);
    },

    storeTicketPost: async ({ state, commit }, inputData) => {
        return await axios.post('support-ticket-post', inputData);
        // No need to handle return data, any return data will be served through socket
    },

    markTicketSeen: async ({ state, commit }, inputData) => {
        console.log('markTicketSeen', inputData);
        return await axios.put('support-ticket/' + inputData + '/mark-as-seen');
    },

    toggleClosed: async ({ state, commit }, inputData) => {
        console.log('toggleClosed', inputData);
        return await axios.put('support-ticket/' + inputData + '/toggle-close');
    },
}

// mutations
const mutations = {
    setTickets(state, payload) {
        state.tickets = payload;
    },

    updateTicket(state, payload) {
        let ticket = state.tickets.find(ticket => ticket.id === payload.id);
        if (ticket) {
            // If last post is not made by the user, mark ticket as unseen
            if (ticket.posts.length > 0 && ticket.posts[ticket.posts.length - 1].user_id !== payload.user_id) {
                ticket.is_seen = false;
            }

            Object.assign(ticket, payload);
        }
    }

    // addPostToTicket(state, payload) {
    //     state.tickets.find(ticket => ticket.id === payload.support_ticket_id).posts.push(payload.post);
    // }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
